<template>
    <!-- Home Banner -->
		<section class="banner-section banner-three">
			<div class="container">
				<div class="row">
					<div class="banner-info-blk">
						<div class="row">
							<div class="col-md-12 col-lg-5">
								<div class="banner-content-blk">

									<h1>Votre prochai<span style="color: #fff">ne</span> trouvaille, à po<span style="color: #fff">rtée</span> de clic.</h1>
									<h5>Trouvez votre trésor  chaque produit, une découverte</h5>
								</div>
							</div>
						</div>
					</div>
					<div class="banner-images">
						<div class="ban-image">
							<img src="../../../assets/img/bg/balloon-img.png" alt="">
						</div>
						<div class="ban-image-01">
							<img src="../../../assets/img/bg/cloud-01.png" alt="" class="cloud-one">
							<img src="../../../assets/img/bg/cloud-02.png" alt="" class="cloud-two">
						</div>
						<div class="ban-image-02">
							<img src="../../../assets/img/main-banner-7.png" alt="">
						</div>
						<div class="ban-image-03">
							<img src="../../../assets/img/bg/plane.png" alt="">
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="banner-btm-img-blk">
							<img src="../../../assets/img/banner-btm-img.png" alt="">
						</div>
						<div class="banner-btm">
							<div class="search-tab-col">
								<b-form action="listing-grid-sidebar" method="post">
									<div class="row align-items-center search-form">
										<div class="col-12 col-lg-10 datepicker-col search-group">
											<ul class="gap-3 d-flex">
												<li>
													<div class="d-flex">
														<div class="flex-shrink-0">
															<div class="icon-blk rounded-circle">
																<span class="material-symbols-outlined">Search</span>
															</div>
														</div>
														<div class="flex-grow-1 ms-3">
															<span class="label">Recherche</span>
															<b-form-input type="text" name="name" class="border-0 text-truncate px-0 form-control" placeholder="Taper votre produit?" />
														</div>
													</div>
												</li>
											</ul>
										</div>
										<div class="col-12 col-lg-2 search-group">
											<ul class="p-0">
												<li>
													<b-button variant="btn theme-btn">Search <i class="feather-search ms-1"></i></b-button>
												</li>
											</ul>
										</div>
									</div>
								</b-form>	
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- /Home Banner -->	
</template>

<script>
export default {
    
}
</script>
